import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Divider } from "@material-ui/core";
import SectionTitle from '../Components/SectionTitle';
import { getConfigItemByParentId } from "store/state/configItems";
import { HEDGE, RATINGS_TRIGGERS } from "constants/configItemParents";
import GridPercentInput from "../Components/GridPercentInput";
import TypeAheadDropdown from "../Components/TypeAheadDropdown";
import GridTextInput from "../Components/GridTextInput";
import { setConfigItemListState } from "../util";
import { transformNumber } from "utils/transformNumber";
import hedgeMap,{hedgeTypes} from 'constants/hedgeTypes';
const SWAP = hedgeMap.SWAP;
class Hedge extends React.Component {
  state = {
    requiredHedges: [],
    ratingsDowngrades: [],
    strike: "",
  };

  static getDerivedStateFromProps(props, state) {
    const { loan } = props;
    return {
      strike: loan.strike || loan.strike === 0 ? loan.strike * 100 : "",
    };
  }

  componentDidMount() {    
    this.props.getConfigItemByParentId({
      id: RATINGS_TRIGGERS
    });
    this.setState({
      requiredHedges:hedgeTypes.filter(x=> x.value === hedgeMap.CAP || x.value === hedgeMap.SWAP).map( x=> {
        return {
          value: x.value,
          label: x.name
        }
      })
    })
  }

  componentDidUpdate = () => {
    if (this.props.configItems && this.props.configItems.configItemByParent) {
      setConfigItemListState(RATINGS_TRIGGERS, "ratingsDowngrades", this);
    }
  };

  render() {
    const {    
      loan,
      handleChange,
      handleTextChange,
      isNewLoan,
      isEditing,
      isInitialized
    } = this.props;

    return (
      <Fragment>
        <span id="loan_hedge">
        <Grid hidden={!isInitialized} item xs={7}>
            <SectionTitle>Hedge</SectionTitle>
        </Grid>
        <Grid container item={true} xs={12}>
          <TypeAheadDropdown
            name="requiredHedgeId"
            label="Required Hedge"
            placeholder="Select a Required Hedge"
            options={this.state.requiredHedges}
            value={loan.requiredHedgeId}
            handleChange={data => handleChange("requiredHedgeId", data)}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridTextInput
            name="hedgeTermMonths"
            label="Term (Months)"
            type="number"
            value={loan.hedgeTermMonths}
            onChange={handleTextChange}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridPercentInput
            name="strike"
            label="Strike"
            value={this.state.strike}
            onBlur={item => {
              handleTextChange({
                target: {
                  name: "strike",
                  value:
                    item.target.value === ""
                      ? ""
                      : transformNumber(item.target.value) / 100
                }
              });
            }}
            isEditing={isEditing}
            shouldShow={isInitialized && loan.requiredHedgeId !== SWAP}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridTextInput
            name="creditCharge"
            label="Credit Charge (bps)"
            type="number"
            value={loan.creditCharge}
            onChange={handleTextChange}
            isEditing={isEditing}
            shouldShow={isInitialized && loan.requiredHedgeId === SWAP}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <TypeAheadDropdown
            name="ratingsDowngradesId"
            label="Ratings Downgrades"
            placeholder="Select a Ratings Downgrade"
            options={this.state.ratingsDowngrades}
            value={loan.ratingsDowngradesId}
            handleChange={data => handleChange("ratingsDowngradesId", data)}
            isEditing={isEditing}
            shouldShow={isInitialized && loan.requiredHedgeId !== SWAP}
          />
        </Grid>
        </span>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { loading, configItems } = state;
  return {
    loading,
    configItems
  };
};

export default compose(
  connect(
    mapStateToProps,
    {
      getConfigItemByParentId
    }
  ),  
)(Hedge);
